module.exports = __webpack_public_path__ + "img/TC.9998cceb.png";